import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  
  //mode :'history',
  //base: '/wrap1/', 
  routes: [
    {
      path: "/home",
      name: "home",
      component: () => import("@/views/Home.vue"),
      meta: {
        tabBarShow: true
      }
    },
    {
      path: "/mine",
      name: "mine",
      component: () => import("@/views/Mine/mine.vue")
    },
    {
      path: "/cart",
      name: "cart",
      component: () => import("@/views/Cart.vue")
    },
    {
      path: "/", 
      name: "equipment",
      component: () => import("@/views/Equipment/equipment.vue"),
      meta: {
        tabBarShow: true,
        keepAlive: true
      }
    },
    {
      path: "/equipmentList/:id?",
      name: "equipmentList",
      component: () => import("@/views/Equipment/equipmentList.vue"),
      meta: {
      	isBack:true,
        tabBarShow: true,
        keepAlive: true
      }
    },
    {
      path: "/jyxz",
      name: "jyxz",
      component: () => import("@/views/Equipment/jyxz.vue"),
      meta: {
        tabBarShow: false,
        keepAlive: false
      }
    },
    {
      path: "/personalInfoList/:id?",
      name: "personalInfoList",
      component: () => import("@/views/Equipment/personalInfoList.vue"),
      meta: {
        tabBarShow: false,
        keepAlive: true
      }
    },
    {
      path: "/equipmentDetails/:id?",
      name: "equipmentDetails",
      component: () => import("@/views/Equipment/equipmentDetails.vue"),
      meta: {
      	title:'谊能科技',
        tabBarShow: false,
        keepAlive: false
      }
    },
    {
      path: "/qcode/:id?",
      name: "qcode",
      component: () => import("@/views/Equipment/qcode.vue")
    },
    {
      path: "/pump",
      name: "pump",
      component: () => import("@/views/Pump/pump.vue"),
      meta: {
        tabBarShow: true
      }
    },
    {
      path: "/pumpTube",
      name: "pumpTube",
      component: () => import("@/views/Pump/pumpTube.vue"),
      meta: {
        tabBarShow: true,
        keepAlive: false
      }
    },
    {
      path: "/pumpConsumables",
      name: "pumpConsumables",
      component: () => import("@/views/Pump/pumpConsumables.vue"),
      meta: {
        tabBarShow: true,
        keepAlive: false
      }
    },
    {
      path: "/pumpDetails",
      name: "pumpDetails",
      component: () => import("@/views/Pump/pumpDetails.vue"),
      meta: {
        tabBarShow: true,
        keepAlive: false
      }
    }
  ]
});




// WEBPACK FOOTER //
// ./src/router/index.js